import request from '@/utils/request';

// 累计种植面积
export async function selCountPdmgCategoryMJ(params) {
  return request.post('/api/bigdata/selCountPdmgCategoryMJ', { ...params });
}
// 累计种植产量
export async function selCountPdmgCategoryCL(params) {
  return request.post('/api/bigdata/selCountPdmgCategoryCL', { ...params });
}
// 累计交易额
export async function selTradingData(params) {
  return request.post('/api/bigdata/selTradingData', { ...params });
}
// 种植规模
export async function selLandToScaleProportion(params) {
  return request.post('/api/bigdata/selLandToScaleProportion', { ...params });
}
// 面积与产量
export async function selPdmgCategoryDate(params) {
  return request.post('/api/stat/pdmgCategory/selPdmgCategoryDate', { ...params });
}
// 实时交易公告板
export async function selTradingBulletinBoard(params) {
  return request.post('/api/bigdata/selTradingBulletinBoard', { ...params });
}
// 地块累计增长趋势
export async function selIncreaseBar(params) {
  return request.post('/api/bigdata/selIncreaseBar', { ...params });
}
// top10种植品种
export async function selPdmgCategoryTrend(params) {
  return request.post('/api/stat/pdmgCategory/selPdmgCategoryTrend', { ...params });
}
// 订单流动
export async function selOrderFlow(params) {
  return request.post('/api/bigdata/selOrderFlow', { ...params });
}
// 交易品类情况 top
export async function selCategoryTradingData(params) {
  return request.post('/api/bigdata/selCategoryTradingData', { ...params });
}
// 累计交易额
export async function selCategoryAmount(params) {
  return request.post('/api/bigdata/selCategoryAmount', { ...params });
}
// 累计用户
export async function statMember(params) {
  return request.post('/api/bigdata/stat/statMember', { ...params });
}
// 店铺数量
export async function statPlatUser(params) {
  return request.post('/api/bigdata/statPlatUser', { ...params });
}
// 商品sku
export async function selGoodsSpecCount(params) {
  return request.post('/api/bigdata/selGoodsSpecCount', { ...params });
}
// 种植户
export async function selStatPlantMember(params) {
  return request.post('/api/bigdata/selStatPlantMember', { ...params });
}
// 种植方案
export async function selRecordRemindSchemeByTotal(params) {
  return request.post('/api/bigdata/selRecordRemindSchemeByTotal', { ...params });
}
// 种植品种
export async function selPzmcByTotal(params) {
  return request.post('/api/bigdata/selPzmcByTotal', { ...params });
}

export async function selStatPdmgDateTrend(params) {
  return request.post('/api/stat/pdmgDate/selStatPdmgDateTrend', { ...params });
}
// 行情趋势图
export async function selPriceOfferGroupByDate(params) {
  return request.post('/api/basic/priceoffer/selPriceOfferGroupByDate', { ...params });
}
